module.exports = __webpack_public_path__ + "errorViewBackground-380x600-ikK.png";